import { Navigate } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Directory from "../pages/directory/page";
import BusinessProfile from "../pages/business/page";
import Categories from "../pages/categories/page";
import Culture from "../pages/culture/page";
import Media from "../pages/media/page";
import ArtistProfile from "@/pages/media/artist/page";
import Login from "../pages/auth/login/page";
import Register from "../pages/auth/register/page";
import ForgotPassword from "../pages/auth/forgot-password/page";
import AuthCallback from "../pages/auth/callback/page";
import ResetPassword from "@/pages/auth/reset-password/page";
import Dashboard from "@/pages/dashboard/page";
import DashboardProfile from "@/pages/dashboard/profile/page";
import DashboardBusiness from "@/pages/dashboard/business/page";
import DashboardMedia from "@/pages/dashboard/media/page";
import DashboardApartments from "@/pages/dashboard/apartments/page";
import DashboardApartmentNew from "@/pages/dashboard/apartments/new/page";
import DashboardApartmentEdit from "@/pages/dashboard/apartments/edit/page";
import DashboardRooms from "@/pages/dashboard/rooms/page";
import DashboardRoomNew from "@/pages/dashboard/rooms/new/page";
import DashboardRoomEdit from "@/pages/dashboard/rooms/edit/page";
import DashboardListings from "@/pages/dashboard/listings/page";
import DashboardListingNew from "@/pages/dashboard/listings/new/page";
import DashboardListingEdit from "@/pages/dashboard/listings/edit/page";
import DashboardJobs from "@/pages/dashboard/jobs/page";
import DashboardJobNew from "@/pages/dashboard/jobs/new/page";
import DashboardJobEdit from "@/pages/dashboard/jobs/edit/page";
import DashboardJobApplications from "@/pages/dashboard/jobs/applications/page";
import DashboardCourses from "@/pages/dashboard/courses/page";
import DashboardCourseNew from "@/pages/dashboard/courses/new/page";
import DashboardCourseEdit from "@/pages/dashboard/courses/edit/page";
import DashboardCourseEnrollments from "@/pages/dashboard/courses/enrollments/page";
import DashboardGigs from "@/pages/dashboard/gigs/page";
import DashboardGigNew from "@/pages/dashboard/gigs/new/page";
import DashboardGigEdit from "@/pages/dashboard/gigs/edit/page";
import DashboardGigOrders from "@/pages/dashboard/gigs/orders/page";
import ProtectedRoute from "@/components/feature/ProtectedRoute";
import Shop from "../pages/shop/page";
import ShopDetail from "../pages/shop/detail/page";
import Work from "../pages/work/page";
import WorkDetail from "../pages/work/detail/page";
import FreelancerProfile from "@/pages/freelancers/detail/page";
import DashboardFreelancer from "@/pages/dashboard/freelancer/page";
import Jobs from "../pages/jobs/page";
import JobDetail from "../pages/jobs/detail/page";
import Learn from "../pages/learn/page";
import LearnDetail from "../pages/learn/detail/page";
import Pay from "../pages/pay/page";
import Pricing from "../pages/pricing/page";
import DashboardSubscription from "@/pages/dashboard/subscription/page";
import Forum from "../pages/forum/page";
import ForumDetail from "@/pages/forum/detail/page";
import DashboardForum from "@/pages/dashboard/forum/page";
import DashboardForumNew from "@/pages/dashboard/forum/new/page";
import DashboardForumEdit from "@/pages/dashboard/forum/edit/page";
import AI from "../pages/ai/page";
import Cloud from "../pages/cloud/page";
import Verify from "../pages/verify/page";
import Support from "../pages/support/page";
import Apartments from "../pages/apartments/page";
import ApartmentDetail from "../pages/apartments/detail/page";
import Listings from "../pages/listings/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail/page";
import Faq from "../pages/faq/page";
import Search from "../pages/search/page";
import Admin from "../pages/admin/page";
import About from "../pages/about/page";
import Author from "../pages/author/page";
import Messages from "@/pages/messages/page";
import Ads from "../pages/ads/page";
import AdsPaymentCallback from "../pages/ads/payment-callback/page";
import AdsPaymentCancelled from "../pages/ads/payment-cancelled/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/directory",
    element: <Directory />,
  },
  {
    path: "/business/:slug",
    element: <BusinessProfile />,
  },
  {
    path: "/categories",
    element: <Categories />,
  },
  {
    path: "/culture",
    element: <Culture />,
  },
  {
    path: "/media",
    element: <Media />,
  },
  {
    path: "/media/artiste/:slug",
    element: <ArtistProfile />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/shop/:id",
    element: <ShopDetail />,
  },
  {
    path: "/work",
    element: <Work />,
  },
  {
    path: "/work/:id",
    element: <WorkDetail />,
  },
  {
    path: "/freelancers/:ownerId",
    element: <FreelancerProfile />,
  },
  {
    path: "/jobs",
    element: <Jobs />,
  },
  {
    path: "/jobs/:id",
    element: <JobDetail />,
  },
  {
    path: "/learn",
    element: <Learn />,
  },
  {
    path: "/learn/:id",
    element: <LearnDetail />,
  },
  {
    path: "/pay",
    element: <Pay />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/forum",
    element: <Forum />,
  },
  {
    path: "/forum/:id",
    element: <ForumDetail />,
  },
  {
    path: "/ai",
    element: <AI />,
  },
  {
    path: "/cloud",
    element: <Cloud />,
  },
  {
    path: "/verify",
    element: <Verify />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/apartments",
    element: <Apartments />,
  },
  {
    path: "/apartments/publish",
    element: <Navigate to="/dashboard/apartments/new" replace />,
  },
  {
    path: "/apartments/:id",
    element: <ApartmentDetail />,
  },
  {
    path: "/annonces",
    element: <Listings />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/author/:slug",
    element: <Author />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/ads",
    element: <Ads />,
  },
  {
    path: "/ads/payment-callback",
    element: <AdsPaymentCallback />,
  },
  {
    path: "/ads/payment-cancelled",
    element: <AdsPaymentCancelled />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute roles={['admin']}>
        <Admin />
      </ProtectedRoute>
    ),
  },
  {
    path: "/messages",
    element: (
      <ProtectedRoute>
        <Messages />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/profile",
    element: (
      <ProtectedRoute>
        <DashboardProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/subscription",
    element: (
      <ProtectedRoute>
        <DashboardSubscription />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/business",
    element: (
      <ProtectedRoute>
        <DashboardBusiness />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/media",
    element: (
      <ProtectedRoute>
        <DashboardMedia />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/apartments",
    element: (
      <ProtectedRoute>
        <DashboardApartments />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/apartments/new",
    element: (
      <ProtectedRoute>
        <DashboardApartmentNew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/apartments/:id/edit",
    element: (
      <ProtectedRoute>
        <DashboardApartmentEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/rooms",
    element: (
      <ProtectedRoute>
        <DashboardRooms />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/rooms/new",
    element: (
      <ProtectedRoute>
        <DashboardRoomNew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/rooms/:id/edit",
    element: (
      <ProtectedRoute>
        <DashboardRoomEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/listings",
    element: (
      <ProtectedRoute>
        <DashboardListings />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/listings/new",
    element: (
      <ProtectedRoute>
        <DashboardListingNew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/listings/:id/edit",
    element: (
      <ProtectedRoute>
        <DashboardListingEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/jobs",
    element: (
      <ProtectedRoute>
        <DashboardJobs />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/jobs/new",
    element: (
      <ProtectedRoute>
        <DashboardJobNew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/jobs/:id/edit",
    element: (
      <ProtectedRoute>
        <DashboardJobEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/jobs/:id/applications",
    element: (
      <ProtectedRoute>
        <DashboardJobApplications />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/courses",
    element: (
      <ProtectedRoute>
        <DashboardCourses />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/courses/new",
    element: (
      <ProtectedRoute>
        <DashboardCourseNew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/courses/:id/edit",
    element: (
      <ProtectedRoute>
        <DashboardCourseEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/courses/:id/enrollments",
    element: (
      <ProtectedRoute>
        <DashboardCourseEnrollments />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/gigs",
    element: (
      <ProtectedRoute>
        <DashboardGigs />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/gigs/new",
    element: (
      <ProtectedRoute>
        <DashboardGigNew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/gigs/:id/edit",
    element: (
      <ProtectedRoute>
        <DashboardGigEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/gigs/:id/orders",
    element: (
      <ProtectedRoute>
        <DashboardGigOrders />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/freelancer",
    element: (
      <ProtectedRoute>
        <DashboardFreelancer />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/forum",
    element: (
      <ProtectedRoute>
        <DashboardForum />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/forum/new",
    element: (
      <ProtectedRoute>
        <DashboardForumNew />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard/forum/:id/edit",
    element: (
      <ProtectedRoute>
        <DashboardForumEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/register",
    element: <Register />,
  },
  {
    path: "/auth/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/auth/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;